<template>
    <div class="assistance">
		<b-modal
			no-close-on-backdrop
			title="Detail"
			class="modal-success"
			v-model="rowDetail"
			ok-variant="success"
            :ok-only="!showViewReportButton"
			ok-title="Close"
			size="xl"
            @ok="rowDetail=false"
		>
            <template #modal-footer="{ ok }">
                <b-button
                    v-if="showViewReportButton"
                    variant="primary"
                    @click="onViewReport"
                >
                    View Report
                </b-button>
                <b-button variant="success" @click="ok()">Close</b-button>
            </template>
			<b-container fluid class="dlgtable">
				<b-row class="ul"><b-col cols="3"><b>Machine</b></b-col><b-col cols="9">{{rowData.machine}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Client Code</b></b-col><b-col cols="9">{{rowData.clientcode}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Type of Assistance</b></b-col><b-col cols="9">{{rowData.type}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Remote / On Site</b></b-col><b-col cols="9">{{rowData.ticketrem}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Total Hours</b></b-col><b-col cols="9">{{rowData.hours}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Start Date</b></b-col><b-col cols="9">{{rowData.datefrom}}</b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>End Date</b></b-col><b-col cols="9">{{rowData.dateto}}</b-col></b-row>
                <b-row class="ul"><b-col cols="3"><b>Status History</b></b-col>
                    <b-col cols="9">
                        <b-row v-for="(t,i) of rowData.trans" :key="i">
                            <b-col cols="3">{{t.data}}</b-col>
                            <b-col cols="9">{{t.status_description}}</b-col>
                        </b-row>
                    </b-col>
                </b-row>
				<b-row class="ul"><b-col cols="3"><b>Subject</b></b-col><b-col cols="9"><pre>{{rowData.subject}}</pre></b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Description</b></b-col><b-col cols="9"><pre>{{rowData.descr}}</pre></b-col></b-row>
				<b-row class="ul"><b-col cols="3"><b>Technician</b></b-col><b-col cols="9">{{rowData.operator}}</b-col></b-row>
			</b-container>
		</b-modal>
        <b-modal
            no-close-on-backdrop
            title="Report Preview"
            class="modal-success"
            v-model="reportDlg"
            ok-variant="success"
            :ok-only="true"
            ok-title="Close"
            size="lg"
            @ok="reportDlg = false"
        >
            <div v-if="pdfpages>1">
                <button @click="pdfpage = pdfpage - 1" :disabled="pdfpage == 1">&#9111;</button>
                {{ pdfpage }} / {{ pdfpages }}
                <button @click="pdfpage = pdfpage + 1" :disabled="pdfpage == pdfpages">&#9112;</button>
            </div>
            <pdf :src="pdfsrc" :page="pdfpage" style="display: inline-block; width: 100%" @num-pages="pdfpages = $event" @page-loaded="pdfpage = $event">
            </pdf>
        </b-modal>
        <b-tabs content-class="mt-3" @input="tabChanged">
            <b-tab title="Archive" active>
                <div class="info" style="float: left;padding-left:20px;text-align: left;font-size: x-small;">
                                <div>Assistance data are available <b>from 2018 onwards</b></div>
                                <div>due to a switch to a different archive procedure</div>
                                <div>Double click on a row to see details</div>
                            </div>
                <b-button @click="openTicket()" v-if="!openticket && !addop && !$store.getters.ro && isClient" class="marsilli" >Open a New Ticket</b-button>
				<b-button @click="addOp()" v-if="!addop && !openticket && !$store.getters.ro && isClient" class="addop marsilli">Register Your Intervention</b-button>
                <div style="clear: both;"></div>
                <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="info"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    >
                    Data Sent
                </b-alert>
                <b-container fluid v-if="!openticket && !addop">
                    <b-row>
                        <b-col>
                            <AgGridVue
                                :style="`width: calc(100% - 0px); height: calc(100vh - ${tblHeight || 235}px)`"
                                class="ag-theme-alpine"
                                :columnDefs="columnDefs"
                                :rowData="assistance"
                                :defaultColDef="defaultColDef"
                                :suppressColumnVirtualisation="false"
                                @first-data-rendered="onFirstDataRendered"
                                @grid-ready="onGridReady"
								@row-double-clicked="onRowDoubleClicked"
                            >
                            </AgGridVue>
                        </b-col>
                    </b-row>
                </b-container>
                <b-card title="Add/Edit a custom intervention" class="editop" v-if="addop">
                    <div>
                        <b-form @submit.prevent="onSubmitOp" @reset="onResetOp">
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-1" label="Unit" label-for="input-unit" >
                                        <b-form-select v-model="formOp.mcode" :options="units" required></b-form-select>
                                    </b-form-group>
                                    <b-form-group id="input-group-1" label="Type" label-for="input-type" >
                                        <b-form-input id="input-type" v-model="formOp.type" type="text" placeholder="Type of intervention" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-2" label="Hours" label-for="input-hours" >
                                        <b-form-input id="input-hours" v-model="formOp.hours" type="number" placeholder="Number of hours spent" required />
									</b-form-group>
                                    <b-form-group id="input-group-4" label="Date From" label-for="input-date1" >
                                        <b-form-input id="input-date1" v-model="formOp.dateFrom" type="date" placeholder="Start Date" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-4" label="Date To" label-for="input-date2" >
                                        <b-form-input id="input-date2" v-model="formOp.dateTo" type="date" placeholder="End Date" required />
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-1" label="Subject" label-for="input-type" >
                                        <b-form-input id="input-type" v-model="formOp.subject" type="text" placeholder="Subject" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-1" label="Description" label-for="input-type" >
                                        <b-form-input id="input-type" v-model="formOp.description" type="text" placeholder="Description" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-1" label="Operator" label-for="input-type" >
                                        <b-form-input id="input-type" v-model="formOp.operator" type="text" placeholder="Operator" required />
                                    </b-form-group>
                                    <b-form-group id="input-group-1" label="Urgent" label-for="input-type" >
                                        <b-form-input id="input-type" v-model="formOp.urgent" type="text" placeholder="Level of Urgency" required />
                                    </b-form-group>
                                </b-col>
                                <b-col>
									<img :src="imgOp" width="100%" v-if="!!imgOp" />
                                    Insert Detail Image:
                                    <b-form-file
                                        v-model="fileOp"
                                        accept="image/*"
                                        :state="Boolean(fileOp)"
                                        placeholder="Choose a file or drop it here..."
                                        drop-placeholder="Drop file here..."
                                    ></b-form-file>
                                    <div class="mt-3">Selected file: {{ fileOp ? fileOp.name : '' }}</div>
                                    <b-button @click="fileOp = null" v-if="Boolean(fileOp)">Reset</b-button>
                                </b-col>
                            </b-row>
                            <b-button type="submit" variant="primary">Submit</b-button>
                            <b-button type="button" @click.prevent="addop=false" variant="danger">Cancel</b-button>
                        </b-form>
                    </div>
                </b-card>
                <b-card class="openticket" title="Open a New Ticket" v-if="openticket">
                    <b-alert v-model="showRequiredFieldMissing" variant="danger" dismissible>
                        one or more fields are missing
                    </b-alert>                    
                    <div>
                        <b-form @submit="onSubmit" @reset="onReset" id="newticket">
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-1"
                                        label="Company"
                                        label-for="input-company"
                                        _description="Company name"
                                    >
                                        <b-form-input
                                            id="input-company"
                                            v-model="form.company"
                                            type="text"
                                            placeholder="Company name"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-2"
                                        label="Contact person"
                                        label-for="input-contpers"
                                        _description="Contact person"
                                    >
                                        <b-form-input
                                            id="input-contpers"
                                            v-model="form.contPers"
                                            type="text"
                                            placeholder="Contact Person"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-8"
                                        label="Contact Phone number"
                                        label-for="input-phone"
                                    >
                                        <b-form-input
                                            id="input-phone"
                                            v-model="form.phone"
                                            type="text"
                                            placeholder="Enter the phone number to contact for more information"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-3"
                                        label="Select your machine"
                                        label-for="input-machine"
                                        _description="Select your machine"
                                    >
                                        <b-form-select
                                            id="input-machine"
                                            v-model="form.machine"
                                            :options="machines"
                                            placeholder="Select your machine"
                                            required
                                        ></b-form-select>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-4"
                                        label="Subject"
                                        label-for="input-subject"
                                        _description="Subject"
                                    >
                                        <b-form-input
                                            id="input-subject"
                                            v-model="form.subject"
                                            type="text"
                                            placeholder="Subject"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                        id="input-group-5"
                                        label="Intervention Type"
                                        label-for="input-tipoInt"
                                    >
                                        <b-form-select
                                            id="input-tipoInt"
                                            v-model="form.tipoInt"
                                            :options="tipoInts"
                                            placeholder="Intervention Type"
                                            required
                                        ></b-form-select>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-6"
                                        label="Issue type"
                                        label-for="input-classProb"
                                    >
                                        <b-form-select
                                            id="input-classProb"
                                            v-model="form.classProb"
                                            :options="classProbs"
                                            placeholder="Issue type"
                                            required
                                        ></b-form-select>
                                    </b-form-group>
                                    <b-form-file
                                        v-model="file"
                                        :state="Boolean(file)"
                                        placeholder="Choose a PDF/JPG file or drop it here..."
                                        drop-placeholder="Drop PDF/JPG file here..."
                                        accept="application/pdf,image/jpeg"
                                    ></b-form-file>
                                    <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>
                                    <b-button @click="file = null" v-if="Boolean(file)">Reset</b-button>
                                    <br><br>
                                    <b-form-group
                                        id="input-group-7"
                                        label="Urgent (Call us !!)"
                                        label-for="input-urgent"
                                    >
                                        <b-form-checkbox
                                            id="input-urgent"
                                            v-model="form.urgent"
                                        ></b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-8"
                                        label="Line Down (Call us !!)"
                                        label-for="input-down"
                                    >
                                        <b-form-checkbox
                                            id="input-down"
                                            v-model="form.down"
                                        ></b-form-checkbox>
                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-7"
                                        label="Description"
                                        label-for="input-description"
                                        _description="Description"
                                    >
                                        <b-form-textarea
                                            id="input-description"
                                            v-model="form.description"
                                            rows="7"
                                            placeholder="Description"
                                            required
                                        ></b-form-textarea>
                                    </b-form-group>

                                </b-col>
                            </b-row>
                            <div>
                                Click on “Submit” to send the ticket to our Service Dept.
                                <br>
                                If you do not receive a confirmation e-mail within a few minutes, it might be possibile that your firewall is blocking the sending of the ticket. In this case, we suggest you to call us!
                            </div>
                            <b-button type="button" @click.prevent="openticket=false" variant="danger">Cancel</b-button>
                            <b-button type="submit" variant="primary">Submit</b-button>
                        </b-form>
                    </div>
                </b-card>
            </b-tab>
            <b-tab title="Analytics">
                <div class="analytics" :style="`max-height: calc(100vh - ${anaHeight || 190}px);`">
                    <b-row>
                        <b-col>
                            <b-card
                                class="chart"
                                :key="codici"
                                :title="`Total Assistance hours (${total})`"
                            >
                                <b-row>
                                    <b-col cols="4">
                                        <div>By Assistance Category</div>
                                        <TotalAssistanceHoursPieChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="type"
                                            @total="setTotal"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>Paying|Free|Included</div>
                                        <TotalAssistanceHoursPieChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="pay"
                                            @total="setTotal"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>Paying|Free|Included By Equipment</div>
                                        <TotalAssistanceTypeBarChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            @total="setTotal"
                                        />
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-card
                                class="chart"
                                :key="codici"
                                :title="`Total Hours (Remote/Onsite) Assistance (${total})`"
                            >
                                <b-row>
                                    <b-col cols="4">
                                        <div>By Equipment</div>
                                        <TotalAssistanceTicketAssBarChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="ore"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>By Year</div>
                                        <TotalAssistanceTicketAssBarChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="ore"
                                            :years="true"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>Split Remote/Onsite</div>
                                        <TotalAssistanceHoursPieChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="ticketrem"
                                            @total="setTotal"
                                        />
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-card
                                class="chart"
                                :key="codici"
                                :title="`Total Interventions (Remote/Onsite) Assistance (${totalk})`"
                            >
                                <b-row>
                                    <b-col cols="4">
                                        <div>By Equipment</div>
                                        <TotalAssistanceTicketAssBarChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="k"
                                            @totalk="setTotalk"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>By Year</div>
                                        <TotalAssistanceTicketAssBarChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                            field="k"
                                            @totalk="setTotalk"
                                            :years="true"
                                        />
                                    </b-col>
                                    <b-col cols="4">
                                        <div>Split Remote/Onsite</div>
                                        <TotalAssistanceTicketAssPieChart
                                            :width="200"
                                            :height="100"
                                            :mcode="codici"
                                        />
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import { API } from "@/api.js";
import TotalAssistanceHoursPieChart from "@/components/TotalAssistanceHoursPieChart.vue";
import TotalAssistanceTicketAssBarChart from "@/components/TotalAssistanceTicketAssBarChart.vue";
import TotalAssistanceTicketAssPieChart from "@/components/TotalAssistanceTicketAssPieChart.vue";
import TotalAssistanceTypeBarChart from "@/components/TotalAssistanceTypeBarChart.vue";
import pdf from "vue-pdf";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
    name: "Assistance",
    components: {
        TotalAssistanceHoursPieChart,
        TotalAssistanceTicketAssBarChart,
        TotalAssistanceTicketAssPieChart,
        TotalAssistanceTypeBarChart,
        pdf,
        AgGridVue,
    },
    data() {
		let ccode = this.$store.getters.client_code
        return {
            showRequiredFieldMissing: false,
            rowDetail: false,
            rowData: {},
			dismissCountDown: 0,
			dismissSecs: 5,
            currTab: 0,
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [
                { hide: !!this.asComp, headerName: "Machine", field: "unit", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { hide: !!this.asComp || ccode!=null, headerName: "Client Code", field: "clientcode", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { hide: true, field: "id" },
                { headerName: "Type of Assistance", cellClass: 'ag-left-aligned-cell', field: "type", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                // { headerName: "Priority", field: "urgent", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Remote / On Site", field: "ticketrem", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Total Hours", cellClass: 'ag-right-aligned-cell', field: "hours", filter: 'agNumberColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Start Date", field: "datefrom", sort: { direction: 'desc', priority: 0 }, filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "End Date", field: "dateto", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "ID", field: "mid", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Status", field: "status_description", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, 
                  cellRenderer: params => { if(params.value) { if(params.value.includes('closed')) return `<span class=tred>${params.value}</span>`
                                                               else  if(params.value.includes('created')) return `<span class=tgreen>${params.value}</span>`
                                                               else return `<span class=torange>${params.value}</span>` }
                                            else return `<span>${params.value}</span>` }
                },
                // { headerName: "Subject", maxWidth: '200', editable: true, cellClass: 'ag-left-aligned-cell', field: "subject", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                // { headerName: "Description", maxWidth: 350, editable: true, cellClass: 'ag-left-aligned-cell', field: "descr", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Technician", cellClass: 'ag-left-aligned-cell', field: "operator", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
            ],
			formOp: {
                unit: null,
				type: null,
				hours: null,
				dateFrom: null,
				dateTo: null,
				subject: null,
				description: null,
				operator: null,
				urgent: null,
			},
            units: [],
			fileOp: null,
			imgOp: null, // per la dialog
			form: {
				company: null,
				contPers: null,
				phone: null,
				machine: null,
				subject: null,
				tipoInt: null,
				classProb: null,
				description: null,
                urgent: null,
                down: null,
			},
			file: null,
			openticket: false,
			addop: false,
			opId: false,
            total: 0, // il totale è lo stesso per tutti i grafici pie
            totalk: 0, // totale numero interventi
            filter: "",
            assistance: [],
			machines: [],
			firstPaint: false,
            isReportPDF: false,
            reportDlg: false,
            pdfsrc: undefined,
            pdfpage: 1,
            pdfpages: 1,
        };
    },
    props: {
        m: Object,
		asComp: Boolean,
        tblHeight: Number,
        anaHeight: Number,
    },
    async mounted() {
        await this.loadData()
        this.machines = (await API.getUnits(false,'servicecare')).map(u => u.code + " - " + u.name)
        this.machines.unshift({id:0, text:""})
        this.units = (await API.getUnits(false,'servicecare')).map((u) => ({value:u.code, text:u.code + " - " + u.name}));
		// setTimeout(() => {
		// 	this.columnApi.autoSizeAllColumns();
		// }, 1000);
    },
    computed: {
		tipoInts(){
			return ["","Installation", "Maintenance", "Technical Assistance", "Training", "Moving"]
		},
		classProbs(){
			return ["","Mechanical", "Software", "Electrical", "Other"]
		},
        showViewReportButton() {
            const ticketOnsite = (this.rowData?.ticketrem || "").toString().trim();
            let ok = ticketOnsite.toLowerCase().startsWith("onsite") && this.isReportPDF;
            return ok;
        },
        codici() {
            return this.m?.codice;
        },
        isClient() {
            return !!this.$store.getters.client_code;
        },
    },
    methods: {
        async loadData(){
            let assistance = await API.getAssistance(this.m?.codice);
            this.assistance = assistance.map((t) => ({
                ...t,
                unit: t.machine,
                descr: t.technicalreport,
                hours: t.ore,
                datefrom: new Date(t.datefrom),
                dateto: new Date(t.dateto),
                datestatus: new Date(t.data),
            }));
            // console.log("assistance", this.assistance);
        },
		async onRowDoubleClicked(params){
            console.log("onRowDoubleClicked", params.data)
            this.isReportPDF = (await API.isReportPDF(params.data.mid)).exists
			console.log("isReportPDF", this.isReportPDF)
			// posso editare solo le righe custom (interventi del cliente)
			console.log(params.data)
			console.log(params.data.datefrom.toISOString().split('T')[0])
			if(params.data.id) {
                this.opId = params.data.id
				this.formOp = params.data
                this.formOp.description = this.formOp.technicalreport
				this.formOp.dateFrom = (new Date(params.data.datefrom)).toISOString().split('T')[0]
				this.formOp.dateTo = (new Date(params.data.dateto)).toISOString().split('T')[0]
				this.addop = true

				// console.log(".... ")
				let apiret = await API.diaryImage(params.data.machine,params.data.image)
				// console.log("IMG",apiret)
				this.imgOp = "data:image/jpg;base64, " + apiret
			} else {
                console.log("this.rowData",this.rowData)
                this.opId = false
                this.rowDetail = true
                // recupero i dati delle transazioni
                params.data.trans = (await API.getAssStato(params.data.mid)).map(t => ({
                    data: (new Date(t.data)).toISOString().split('T')[0],
                    status_description: t.status_description
                }))
                // elimino quelle successive ad una chiusura
                let idx = params.data.trans.findIndex( t => t.status_description.includes("closed"))
                if(idx>=0) {
                    params.data.trans = params.data.trans.slice(0,idx+1)
                }
                this.rowData = params.data
            }
		},
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
        onGridReady(params) {
			console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
			this.columnApi.applyColumnState({
				state: [{ colId: 'datefrom', sort: 'desc' }],
				defaultState: { sort: null },
			});
        },
		// eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            if(this.currTab==0) {
                this.columnApi.autoSizeAllColumns();
				console.log("autoSizeAllColumns1")
			}
        },
        tabChanged(index) {
            this.currTab = index;
            if (index == 0) {
                // la grid
                setTimeout(() => {
                    this.columnApi.autoSizeAllColumns();
					console.log("autoSizeAllColumns2")
                }, 1000);
            }
        },
		async openTicket(){
			this.openticket = true
			for(let fld in this.form){
				this.form[fld] = null
			}
			this.form.company = await API.getClientName()
			this.form.contPers = this.$store.getters.name + " " + this.$store.getters.surname
		},
		async addOp(){
			this.addop = true
			for(let fld in this.formOp){
				this.formOp[fld] = null
			}
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
		showAlert() {
			this.dismissCountDown = this.dismissSecs
		},
        setTotal(total) {
            this.total = Math.round(total);
        },
        setTotalk(totalk) {
            this.totalk = totalk;
        },
		async onSubmit(){
            // let ok = document.getElementById("newticket").checkValidity()
            // if(!ok) {
            //     this.showRequiredFieldMissing
            //     return
            // }
			const formData = new FormData()
			formData.append('data', JSON.stringify(this.form))
			formData.append('upload', this.file)
			await API.sendTicket(formData)
			this.openticket = false
			this.showAlert()
		},
		async onSubmitOp(){
            let ccode = this.$store.getters.client_code
			const formData = new FormData()
			let m = this.$store.getters.machine
			console.log("this.$store.getters.machine",m)
			// this.formOp.mcode = m.codice
			this.formOp.clientcode = ccode
			this.formOp.id = this.opId
			formData.append('data', JSON.stringify(this.formOp))
			formData.append('upload', this.fileOp)
			await API.sendDiary(formData)
            await this.loadData()
			this.addop = false
			this.showAlert()
		},
		onReset(){
		},
		onResetOp(){
		},
        async onViewReport(){
            if (!this.rowData?.mid) {
                return
            }
            let pdf = await API.getReportPDF(this.rowData.mid)
            if (pdf) {
                this.openPDF(pdf)
            }
        },
        openPDF(pdf) {
            const blob = new Blob([pdf]);
            const objectUrl = URL.createObjectURL(blob, { type: 'application/pdf' });
            this.pdfsrc = objectUrl
            this.pdfpage = 1
            this.pdfpages = 1
            this.reportDlg = true
        },
    },
};
</script>
<style>
div.assistance span.tred {
    color: red;
    font-weight: 700;
}
div.assistance span.tgreen {
    color: green;
    font-weight: 700;
}
div.assistance span.torange {
    color: orange;
    font-weight: 700;
}
div.dlgtable div.row:nth-child(even){
    background-color: #fafafa;
}
div.assistance td,
div.assistance th {
    text-align: left;
}
div.assistance td , div.assistance th{
    text-align: left;
}
div.assistance div.mb-0 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}
.ag-left-aligned-cell {
    text-align: left;
}
</style>
<style scoped>
div.card.openticket div.card-body {
    overflow-y: auto;
    height: calc(100vh - 330px);
}
div.ul {
    border-bottom: 1px solid rgba(0,0,0,.2);
}
div.dlgtable pre {
	white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
}
button.marsilli {
    background-color: #6b1106;
    border-color: #6b1106;
}
div.editop div.card-body {
    overflow-y: auto;
    height: calc(100vh - 265px);
}
div.analytics {
    overflow-y: auto;
    overflow-x: hidden;
}
button.addop {
	float: right;
    margin-right: 15px;
}
#newticket button {
    margin: 10px;
}
</style>
